import { render, staticRenderFns } from "./requirement.vue?vue&type=template&id=66d161c8&"
import script from "./requirement.vue?vue&type=script&lang=js&"
export * from "./requirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports